import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// Locale JSON lives in `public/locales/<lng>/common.json` and is served as a
// static asset at `/locales/<lng>/common.json`. Both en and hi load through
// the HttpBackend below — bundling en inline (via `import enCommon from …`)
// would double-ship the file (once in the JS bundle, once as a public asset)
// and Vite rightly refuses such imports from `public/`. With Suspense enabled
// the first paint waits for the initial fetch, which is one short HTTP round
// trip on app boot — small enough that the static-asset double-ship isn't
// worth the trouble.

const isDev = process.env.NODE_ENV !== 'production';

i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        // Scope: en (source) + hi (operator-validated). Other Indic locales
        // (mr, ta, te, kn, ml) were dropped from the active pipeline until each
        // has its own operator-validated glossary — see scripts/i18n/glossary.json
        // and scripts/translate.mjs LANGUAGES.
        supportedLngs: ['en', 'hi'],
        ns: ['common'],
        defaultNS: 'common',

        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
        detection: {
            order: ['localStorage', 'navigator'],
            lookupLocalStorage: 'i18nextLng',
            caches: ['localStorage'],
        },
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: true,
        },

        // --- Smart Extraction (dev only) ---
        // Logs every missing t() key to console so you can discover them as you browse
        saveMissing: isDev,
        missingKeyHandler: isDev
            ? (_lngs: readonly string[], ns: string, key: string, fallbackValue: string) => {
                console.warn(`[i18n] Missing key: "${ns}:${key}" → fallback: "${fallbackValue}"`);
            }
            : false,
    });

export const setAppLanguage = (lang?: string | null) => {
    if (!lang || i18n.language === lang) return;
    i18n.changeLanguage(lang);
    try {
        localStorage.setItem('i18nextLng', lang);
        document.documentElement.setAttribute('lang', lang);
    } catch {}
};

export default i18n;
